$(function() {

	// SWIPE CONTROLS
	var $navbar = $("#navbar");
	$navbar.swipe({
		swipeLeft: function() {
			window.offcanvas.offCanvasOn("right");
		},
		swipeRight: function() {
			window.offcanvas.offCanvasOn("left");
		},
		swipeDown: function() {
			window.offcanvas.aniToggleSearch();
		}
	});

	// ADDING .scrolled

	$(window).on("scroll", function(e) {
		if ($(window).scrollTop() > 10) {
			$(document.body).addClass("scrolled");
		} else {
			$(document.body).removeClass("scrolled");
		}
	})

	// MAIN BUTTONS CONTROL

	$("#toggler-menu").on("click", function() {
		window.offcanvas.offCanvasToggle('left');
		return false;
	});
	$("#toggler-search").on("click", function() {
		offcanvas.toggleSearch();
		return false;
	});
	$("#toggler-contact").on("click", function() {
		window.offcanvas.offCanvasToggle('right');
		return false;
	});

});